import React from 'react';

const PageFooter = () => <p>MSS Strategic Partners &copy; {new Date().getFullYear()}</p>;

export default PageFooter;
